import { login, logout, getInfo } from '@/api/user'
// import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  // token: getToken(),
  name: '',
  userId: '',
  isGetInfo: false,
  roles: []
}

const mutations = {
  // SET_TOKEN: (state, token) => {
  //   state.token = token
  // },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ISGETINFO: (state, isGetInfo) => {
    state.isGetInfo = isGetInfo
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: username.trim(), pwd: password }).then(response => {
        // commit('SET_TOKEN', response.token)
        commit('SET_NAME', response.name)
        commit('SET_USERID', response.userId)
        // setToken(response.token)
        resolve()
      }).catch(error => {
        reject(error)
      }).finally(() =>{
        commit('SET_ISGETINFO', true)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          // reject('Verification failed, please Login again.')
          resolve(data)
        }

        // const { roles, name, avatar, introduction } = data
        const { name, userId } = data

        // commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_USERID', userId)
        // commit('SET_AVATAR', avatar)
        // commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      }).finally(() =>{
        commit('SET_ISGETINFO', true)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        // commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_USERID', '')
        commit('SET_ROLES', [])
        // removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  // resetToken({ commit }) {
  //   return new Promise(resolve => {
  //     commit('SET_TOKEN', '')
  //     commit('SET_ROLES', [])
  //     removeToken()
  //     resolve()
  //   })
  // }
}
const getters = {
  // token: state => state.token,
  userId: state => state.userId,
  isGetInfo: state => state.isGetInfo,
  name: state => state.name,
  roles: state => state.roles,
}

export default {
  namespaced: true, // 启用命名空间
  state,
  mutations,
  actions,
  getters
}
